import React from 'react';
import Module from 'Components/Core/Module';
import DialogForm from 'Components/Core/DialogForm';
import Table from './Table';

export default function ModuleTable(props) {

    const x = props.x;

	const wafId = props.id;
	const dialogFormId = props.dialogFormId;

	const [loadTable, setLoadTable] = React.useState(1);

	const focusField = (typeof props.focusField === 'undefined') ? 'name' : props.focusField;
	const sendButtonLevel = (typeof props.sendButtonLevel === 'undefined') ? 4 : props.sendButtonLevel;
	const hideTable = (typeof props.hideTable === 'undefined') ? false : props.hideTable;
	const onAddColumn = (typeof props.onAddColumn === 'undefined') ? (key, value) => { return value } : props.onAddColumn;
	const onAddFooter = (typeof props.onAddFooter === 'undefined') ? () => { return null } : props.onAddFooter;
	const onAddHeader = (typeof props.onAddHeader === 'undefined') ? () => { return null } : props.onAddHeader;
	const onRowEdit = (typeof props.onEditRow === 'undefined') ? () => { return null } : props.onEditRow;

	React.useEffect(() => {
		if (x.was.memberLevel > 2) {
			if (x.waf.isField(wafId, 'name')) x.waf.disable(wafId, 'name');
			if (x.waf.isField(wafId, 'description')) x.waf.disable(wafId, 'description');
			if (x.waf.isField(wafId, 'disabled')) x.waf.disable(wafId, 'disabled');
		}
	});

	x.wam.init(props.id, {
		"onClose": () => {
			delete x.waf[wafId];
		}
	})

	const reloadKeyMounted = React.useRef(false);

	function reloadTable() {
		setLoadTable(currentValue => currentValue + 1);
	}

	function afterSend(result) {
		reloadTable();
		if (typeof props.onAfterSend !== 'undefined') props.onAfterSend(result);
	}

	React.useEffect(() => {
		if (typeof props.reloadKey === 'undefined') return;
		if (reloadKeyMounted.current) reloadTable();
		reloadKeyMounted.current = true;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.reloadKey]);
	
	function addRow() {
		x.waf.setAddSend(wafId, props.tableId, 0);
		if (x.waf.isField(wafId, 'name')) x.waf.set(wafId, 'name', '');
		if (x.waf.isField(wafId, 'description')) x.waf.set(wafId, 'description', '');
		if (x.waf.isField(wafId, 'forumid')) { x.waf.set(wafId, 'forumid', ''); x.waf.setKey(wafId, 'forumid', 0); }
		x.waf.hide(wafId, 'message');
		x.wad[dialogFormId].setTitle(props.addTitle);
		x.wad[dialogFormId].show(() => { x.waf.focus(wafId, focusField) });
	}

	function onDeleteClick(e, rowFields) {
		props.onDeleteClick(e, rowFields);
	}

	const moduleToolbar =
		(x.was.memberLevel < 3 && props.hideAddButton !== true)
			?
			<span className={` bi bi-plus-square module-icon  `} title={props.addTitle} onClick={() => addRow()}>
			</span>
			: null;

	return (
		<Module
			id={props.id}
			x={x}
			classes={`${props.classes}`}
			title={props.title}
			display="d-block"
			titleToolbar={
				<span className="module-table-title-toolbar">
					{moduleToolbar}
					{props.extraToolbar}
				</span>
			}
			onShow={() => {
				reloadTable();
				if (typeof props.onShow !== 'undefined') props.onShow();
			}}
		>
			<div className="module-table-body">
			{props.toolbar}
			<div className="module-table-table-wrap">
			<Table
				id={props.id + '-table'}
				x={x}
				dialogId={props.id}
				hideTable={hideTable}
				loadTable={loadTable}
				module = {props.module}
				listTask={props.listTask}
				listParams={props.listParams}
				deleteTask={props.deleteTask}
				classes={props.tableClasses}
				noTitle={false}
				addDeleteRow={props.addDeleteRow}
				deleteRowAllowed={props.addDeleteRow}
				addEditRow={props.addEditRow}
				filterableColumns={props.filterableColumns}
				customFilterRow={props.customFilterRow}
				draggableRows={props.draggableRows}
				onReorder={props.onReorder}
				onRowClasses={props.onRowClasses}
				onAddHeader={(addHeader) => { return onAddHeader(addHeader) }}
				onAddFooter={(addFooter) => { return onAddFooter(addFooter) }}
				onAddColumn={(key, value) => { return onAddColumn(key, value) }}
				onDeleteClick={onDeleteClick}
				onRowEdit={(e, rowFields, rowId) => { onRowEdit(e, rowFields, rowId) }}
				onRowClick={props.onRowClick}
			/>
			</div>
			</div>
			<DialogForm
				id={dialogFormId}
				x={x}
				wafId={wafId}
				title={props.formTitle}
				classes="dialog-new-Section"
				children={props.formFields}
				module={props.module}
				sendTask={props.formSendTask}
				sendButton={(x.was.memberLevel < sendButtonLevel) ? true : false}
				onAfterSend={afterSend}
				onSubmit={props.onFormSubmit}
			/>
		</Module>
	)


};
